// extracted by mini-css-extract-plugin
export default {"textstyles":"text_textstyles__jsFTr","flextext":"text_flextext__R6Doz"};